import moment from 'moment'

/* constantes */
const COLORS = {
  green: '#7AB648',
  yellow: '#FFD61F',
  red: '#C92D39',
  orange: '#E67700',
  black: '#424242',
  grey: '#c4c4c4'
};

/* funções */
function selectTabClass(idx, ref, variant, text) {
  let bg = variant || 'bg-success';
  let txt = text || 'text-success';
  if (ref === idx) return bg;
  else return txt;
}

function updateFormatter(update) {
  if (update) {
    update = moment(update, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
  }
  return update;
}

function monitSignal(backendNow, update, unit, limit) {
  backendNow = moment(backendNow);
  update = moment(update);
  return backendNow.diff(update, unit) <= limit;
}

function checkCoord(pos, ref) {
  //converte para número pois Number('') = 0 e '' é permitido para o campo
  pos = Number(pos);
  if (!isNaN(pos) && !(pos < -ref || pos > ref))
    return true;
  return false;
}

function isMobile(ref) {
  if (ref) return window.innerWidth <= ref;
  else return window.innerWidth <= 767;
}

function organizer(arr, key) {
  if (arr.length)
    return arr.sort((a, b) => {
      if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key))
        return 0; // property doesn't exist on either object

      const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) comparison = 1;
      else if (varA < varB) comparison = -1;
      return comparison;
    });
  else return arr;
}
function removeRepeatedTimesVol(table) {
  const flatArray = [...table.flat()];
  flatArray.sort(function (a, b) {
    var c = new Date(a);
    var d = new Date(b);
    return c - d;
  });
  const filteredData = flatArray.reduce((ac, time) => {
    if (ac.indexOf(time) < 0) ac.push(time);
    return ac;
  }, []);
  return Array.from([...filteredData], (t) => Array.of(t));
}
function getTimes(ret) {
  let times = ret.map((el) => {
    return [el.TIME];
  });
  return times;
}

function concatData(reports,datas, callback) {
  let tables = [];
  for (let ret of reports) {
    let reportsLogs = [];
    let reportsTable = [];
    if (ret.VALUE && ret.VALUE.length) {
      // console.log("concatReportsData => ret => ", ret);
      if (datas.equipment == "actuator") {
        //Volume tem que ter datas repetidas
        if (datas.type == "volume") {
          ret.VALUE.sort(function (a, b) {
            var c = new Date(a.TIME);
            var d = new Date(b.TIME);
            return c - d;
          });
          let only_times = getTimes(ret.VALUE);
          let noRepeatedTimes = removeRepeatedTimesVol(only_times);

          reportsLogs = [
            ...reportsLogs,
            { NAME: ret.NAME, VALUE: ret.VALUE },
          ];
          reportsTable = [...reportsTable, ...noRepeatedTimes];
        }

        // console.log("concatReportsData => only_times ", only_times);

        tables.push({ logs: reportsLogs, table: reportsTable });
      }
    }
  }
  // console.log("concatReportsData => table => ", tables);
  callback(tables);

}

function convertArrayToRowsFromDatabase(array) {
  let marks = ""
  const values = []

  //Formatar os dados para inserir no banco
  array.forEach((value) => {
      marks += "("
      Object.keys(value).map(key => {
          marks += "?, "
          values.push(value[key])
      })
      marks = marks.slice(0, marks.length - 2)
      marks += "), "
  })
  marks = marks.slice(0, marks.length - 2)

  return {
      marks,
      values
  }
}

function fixFloatValue(val, defaultValue = 0) {
  if(typeof val === "number" && !isNaN(val)) {
    return parseFloat(val.toFixed(2));
  } else {
    return defaultValue;
  }

}

function calcPercentageRounded(slice, total) {
  let percentageValue = total? (slice / total) * 100 : 0;

  if(percentageValue > 100) {
    return 100;
  } else if(!percentageValue) {
    return 0;
  } else {
    return Number(percentageValue.toFixed(2));
  }
}

function formatToPercentage(decimal,maxDigits=2,minDigits=2) {
  const option = {
    style: "percent",
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  };
  const formatter = new Intl.NumberFormat("en-US",option)
  const percentage = formatter.format(decimal)
  return percentage
}


/* exports */
export {
  COLORS,

  selectTabClass,
  updateFormatter,
  monitSignal,
  isMobile,

  checkCoord,

  organizer,
  concatData,
  removeRepeatedTimesVol,
  getTimes,
  convertArrayToRowsFromDatabase,
  calcPercentageRounded,

  formatToPercentage,
  //Management
  fixFloatValue
}

/*
Checar
*/
